import { render, staticRenderFns } from "./ModalAdicionarAnexo.vue?vue&type=template&id=fa44899c"
import script from "./ModalAdicionarAnexo.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarAnexo.vue?vue&type=script&lang=js"
import style0 from "./ModalAdicionarAnexo.vue?vue&type=style&index=0&id=fa44899c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports